<template>
    <Teleport to="body">
        <div class="fixed top:50% left:50% translate(-50%,-50%) w:288 h:96 r:8 z:999 bg:g100 b:2|solid|g600 grid place-items:center {w:320}@md" v-if="text">
            <div class="flex gap:10 ai:center">
                <img height="20" src="images/success_check.svg" width="20" />
                <p class="font-md color:g600">
                    {{ text }}
                </p>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const seconds = ref(0);
    const text = ref("");

    const countdown = (value) => {
        if (value) {
            seconds.value = value;
        } else if (seconds.value) {
            seconds.value -= 1;
        }

        if (seconds.value) {
            setTimeout(() => countdown(), 1000);
        } else {
            text.value = "";
        }
    };

    const show = (message) => {
        if (message) {
            text.value = message;

            countdown(2);
        }
    };

    defineExpose({ show });
</script>
